export enum REWARD_CITATION_TYPE {
  IMAGE = 'image',
  MANUAL = 'content',
  BOTH = 'both',
}
